export const test = {
  activeInfoTab: 'company',
  isEmailSending: false,
  notifications: {
    items: [],
    count: 0,
  },
  activeNotification: {},
};

export const initial = {
  activeInfoTab: 'company',
  isEmailSending: false,
  notifications: {
    items: [],
    count: 0,
  },
  activeNotification: {},
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/account.state.js
 **/